import React, { useCallback } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { ThreeDotsVertical, Pencil, Trash } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

interface ICardActionsDropdownProps {
  onEdit: () => void;
  onDelete: () => void;
  isEditDisabled?: boolean;
}

const stopPropagationOnly = (event: React.SyntheticEvent) => {
  event.stopPropagation();
};

const stopAll = (event: React.SyntheticEvent) => {
  event.preventDefault();
  event.stopPropagation();
};

const CardActionsDropdown: React.FC<ICardActionsDropdownProps> = ({
  onEdit,
  onDelete,
  isEditDisabled = false,
}) => {
  const { t } = useTranslation();

  const handleEdit = useCallback(
    (event: React.SyntheticEvent) => {
      stopAll(event);
      onEdit();
    },
    [onEdit]
  );

  const handleDelete = useCallback(
    (event: React.SyntheticEvent) => {
      stopAll(event);
      onDelete();
    },
    [onDelete]
  );

  return (
    <div onMouseDown={stopPropagationOnly} onClick={stopPropagationOnly}>
      <Dropdown align="end">
        <Dropdown.Toggle
          as={Button}
          type="button"
          variant="link"
          className="p-0 text-primary d-flex align-items-center lh-1 shadow-none border-0"
          aria-label="actions"
        >
          <ThreeDotsVertical />
        </Dropdown.Toggle>

        <Dropdown.Menu className="py-2 border-grey">
          <Dropdown.Item
            onClick={handleEdit}
            disabled={isEditDisabled}
            className="d-flex align-items-center gap-2"
          >
            <Pencil size={12} />
            <span>{t("Edit")}</span>
          </Dropdown.Item>

          <Dropdown.Item
            onClick={handleDelete}
            className="d-flex align-items-center gap-2 text-danger"
          >
            <Trash size={12} color="#DC3545" />
            <span className="text-error">{t("Delete")}</span>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default React.memo(CardActionsDropdown);
